export const FREE_URL = "https://designstudio.moiraa.xyz/web/checkout/6ac61494ed7c52257e6ef912";
export const PRO_URL = "https://designstudio.moiraa.xyz/web/checkout/6ac4bb47f3318e63ba40f90f";
export const COACHING_URL = "https://designstudio.moiraa.xyz/web/checkout/6ac4bb638a7e591c960365e6";
